import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import TerritoriesContainer from './TerritoriesContainer.tsx';

const queryClient = new QueryClient();

export default function Territories() {
  return (
    <QueryClientProvider client={queryClient}>
      <TerritoriesContainer />
    </QueryClientProvider>
  );
}
